import { easeInOut } from '@utils/constants';
import { isPlatformIOS } from './platform.is-ios.js';

const SCROLL_VELOCITY = 45;
let isRunningScrollTransition = false;
let easingFn;
let forceAutoScroll = false;
let disabledMaxScroll = false;
let scrollStartedAt;
let scrollDurationMs;
let scrollTransitionFrom;
let scrollTransitionTo;
let scrollTransitionPrev;
let scrollContainer;
let hasBoundGlobalEvents = false;
function scrollTo(y, {
  maxDurationMs = Infinity,
  minDurationMs = 0,
  disableMaxScroll = false,
  forceAutoScroll: argForceAutoScroll = false,
  scrollContainer: argScrollContainer,
  easingFn: argEasingFn
} = {}) {
  if (!hasBoundGlobalEvents) {
    if (isPlatformIOS()) {
      window.addEventListener("touchmove", stopScrolling);
    } else {
      window.addEventListener("scroll", onScroll);
    }
    hasBoundGlobalEvents = true;
  }
  if (scrollContainer !== argScrollContainer || !isRunningScrollTransition) {
    scrollTransitionFrom = getScrollTop(argScrollContainer);
  }
  forceAutoScroll = argForceAutoScroll;
  scrollContainer = argScrollContainer;
  disabledMaxScroll = disableMaxScroll;
  easingFn = argEasingFn;
  const maxScrollOffset = disableMaxScroll ? Infinity : getMaxScroll(scrollContainer);
  const nextScrollTransitionTo = Math.max(0, Math.min(maxScrollOffset, y));
  if (isRunningScrollTransition && Math.abs(scrollTransitionTo - nextScrollTransitionTo) < 20) {
    scrollTransitionTo = nextScrollTransitionTo;
    return;
  }
  scrollTransitionTo = nextScrollTransitionTo;
  const distance = Math.abs(scrollTransitionFrom - scrollTransitionTo);
  scrollStartedAt = Date.now();
  scrollDurationMs = Math.max(
    minDurationMs,
    Math.min(maxDurationMs, Math.cbrt(distance) * SCROLL_VELOCITY)
  );
  if (isRunningScrollTransition || scrollTransitionTo === window.pageYOffset) {
    scrollTransitionFrom = getScrollTop(scrollContainer);
    return;
  }
  isRunningScrollTransition = true;
  animateScroll();
}
function stopScrolling() {
  if (!isRunningScrollTransition) {
    return;
  }
  isRunningScrollTransition = false;
  scrollTransitionFrom = window.pageYOffset;
  scrollTransitionTo = window.pageYOffset;
  scrollTransitionPrev = void 0;
  forceAutoScroll = false;
  disabledMaxScroll = false;
  scrollContainer = void 0;
  easingFn = void 0;
}
function isScrolling() {
  return isRunningScrollTransition;
}
function animateScroll() {
  if (!isRunningScrollTransition) {
    return;
  }
  const elapsedMs = Date.now() - scrollStartedAt;
  const rawP = Math.max(0, Math.min(1, elapsedMs / scrollDurationMs));
  const easing = easingFn ?? ((p2) => easeInOut(p2, 3));
  const p = easing(rawP);
  scrollTransitionPrev = scrollTransitionFrom + (scrollTransitionTo - scrollTransitionFrom) * p;
  const maxScrollOffset = getMaxScroll(scrollContainer);
  if (maxScrollOffset === 0 && disabledMaxScroll) {
    requestAnimationFrame(() => {
      scrollStartedAt = Date.now();
      animateScroll();
    });
    return;
  }
  (scrollContainer ?? window).scrollTo({
    top: scrollTransitionPrev,
    behavior: "auto"
  });
  if (p >= 1 || scrollY === scrollTransitionTo) {
    isRunningScrollTransition = false;
    scrollTransitionPrev = void 0;
    forceAutoScroll = false;
    disabledMaxScroll = false;
    scrollContainer = void 0;
  } else {
    requestAnimationFrame(animateScroll);
  }
}
function onScroll() {
  if (!forceAutoScroll && scrollTransitionPrev !== void 0 && Math.abs(window.pageYOffset - scrollTransitionPrev) > 3) {
    stopScrolling();
  }
}
function getMaxScroll(container) {
  return container === void 0 ? document.documentElement.scrollHeight - document.documentElement.clientHeight : container.scrollHeight - container.clientHeight;
}
function getScrollTop(container) {
  return container !== void 0 ? container.scrollTop : window.pageYOffset;
}

export { isScrolling, scrollTo, stopScrolling };
//# sourceMappingURL=dom.scroll-to.js.map
